<script setup lang="ts">
import { getDistance } from '#imports'
const { unit = 'km' } = defineProps<{
  center: number[]
  house: { gpslatitude: number; gpslongitude: number }
  unit?: string
}>()
</script>

<template>
  <div
    v-if="
      center.length === 2 &&
      Number.isFinite(house.gpslatitude) &&
      Number.isFinite(house.gpslongitude)
    "
  >
    {{
      Math.round(
        getDistance(
          house.gpslatitude,
          house.gpslongitude,
          center[1],
          center[0],
        ),
      )
    }}
    {{ unit }}
  </div>
</template>
